/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  CheckUserEmailExistsOptions,
  CheckUserEmailExistsResponses,
} from '../types/CheckUserEmailExists'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Checks email existence within a tenant scope. If `tenant-id` (preferred) or legacy `tenant_id` header is provided, lookup is tenant-specific. If both headers are omitted, the server falls back to the default DORA tenant.
 * @summary Check whether a user email exists
 * {@link /v1/user/exists}
 */
export function checkUserEmailExists<ThrowOnError extends boolean = true>(
  options: Options<CheckUserEmailExistsOptions, ThrowOnError>,
): Unwrappable<RequestResult<CheckUserEmailExistsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/user/exists',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CheckUserEmailExistsResponses, ThrowOnError>>,
  )
}
